import { Fragment } from 'react';
import { Box, Grid, Typography } from '@mui/material';

import { Ti18nId } from 'hooks/useI18n';
import { IFormRegister, IFormValues, IFormWatch } from 'routes/Main/type';

import SectionTitle from '../../components/SectionTitle';

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
  onRequired: (id: Ti18nId) => void;
  onSuccess: (message: string) => void;
}

const CVCone = (props: Props) => {
  const { disabled, register } = props;

  const info = [
    '當病人的臨床狀況不穩定，且需要多種輸液時。',
    '當需長時間或持續從周邊靜脈注射可能引起併發症的藥物（例如：靜脈營養、刺激性藥物、濃縮電解質、高滲溶液等）時。',
    '當需進行侵入性血流動力監測時。',
    '當需長期間歇性輸注時。',
    '即使在超音波導引下，周邊靜脈置管仍困難或失敗的病人。',
  ];

  return (
    <Fragment>
      <SectionTitle title="2. Indications for central venous catheter insertion." />
      <Box sx={{ margin: '38px 0px 30px 20px' }}>
        <Grid container xs={11.8}>
          <Typography sx={{ fontSize: '14px', fontWeight: 400 }}>
            中心靜脈導管的適應症如下{' '}
          </Typography>

          {info.map(a => {
            return (
              <Grid item xs={11.5}>
                <Typography
                  sx={{
                    fontSize: '14px',
                    lineHeight: '30px',
                    whiteSpace: 'pre-wrap',
                  }}
                >
                  • {a}
                </Typography>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </Fragment>
  );
};

export default CVCone;
